import { Image } from '@react-pdf/renderer';
import React from 'react';

export default function ImageFromLocalFile({ src, height, width, ...rest }) {
  return <Image src={src} style={{ height, width }}></Image>;
}
